<template>
  <div></div>
<!--    <div v-if="data" class="kris-documents-box" id="sample-notify">-->
<!--      <div v-if="typeof (data.dou_notify) !== 'undefined' || typeof (data.edu_notify) !== 'undefined' || typeof (data.prof_notify) !== 'undefined'" class="">-->
<!--        <div class="h2">Образцы уведомлений от родителей об отсутствии контактов</div>-->
<!--        <ul class="kris-doclist">-->
<!--          <file v-if="typeof (data.dou_notify) !== 'undefined'" :link="data.dou_notify.file" ext="pdf" :title="data.dou_notify.title" />-->
<!--          <file v-if="typeof (data.edu_notify) !== 'undefined'" :link="data.edu_notify.file" ext="pdf" :title="data.edu_notify.title" />-->
<!--          <file v-if="typeof (data.prof_notify) !== 'undefined'" :link="data.prof_notify.file" ext="pdf" :title="data.prof_notify.title" />-->
<!--        </ul>-->
<!--        <ul class="kris-doclist" v-if="typeof (data.dop) !== 'undefined'">-->
<!--          <file v-bind:key="key" v-for="(item,key) in data.dop" :link="item.file" ext="pdf" :title="item.title" />-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div v-else  class="kris-documents-box">-->
<!--        <span>Загрузка данных...</span>-->
<!--    </div>-->
</template>

<script>
import { mapState } from 'vuex'
import { GET_SAMPLE_NOTIFY } from '../store/actions.type'
import { common } from '../mixins/common'
export default {
  name: 'SampleNotify',
  mixins: [common],
  computed: {
    ...mapState({
      'data': 'dataSampleNotify'
    })
  },
  mounted () {
    this.$store.dispatch(GET_SAMPLE_NOTIFY).then(() => {
      const $this = this
      setTimeout(() => {
        let anchor = $this.getAnchor()
        if (anchor === 'sample-notify') {
          let container = $this.$el
          container.scrollIntoView()
        }
      }, 1000)
    })
  }
}
</script>

<style scoped>

</style>
